import React from 'react';

import SVG from 'react-inlinesvg';
import { FormModal, Text, Link } from '../../../../../../../ui-kit';
import livechat from '../../../../../../../assets/images/livechat.svg';
import '../styles/_livechat-modal.scss';

const HELP_LINK = 'https://shootsta.com/#form-block';











function LiveChatModal({
  visible,
  closeModal,
  saveButtonId = '',
  saveText = 'Done',
  title = 'Please use Live Chat to speak with us!',
  contentHeading = 'So what\'s next?',
  content = 'The team can arrange a discovery call with you to share more information and pricing for Flex Credits.'
}) {
  const onClickHelpLink = () => window.open(HELP_LINK, '_blank');

  const renderFooterChildren = () =>
  <strong><Link onClick={onClickHelpLink}>Live Chat not Loading?</Link></strong>;


  return (
    <FormModal
      className="livechat-modal"
      visible={visible}
      onClose={closeModal}
      showCancelBtn={false}
      saveText={saveText}
      onSave={closeModal}
      footerChildren={renderFooterChildren()}
      title={title}
      size="SM"
      saveButtonId={saveButtonId}>

      <div className="livechat-modal__img">
        <SVG cacheRequests src={livechat} uniquifyIDs title="There's nothing here yet." />
      </div>
      <Text heading5>{contentHeading}</Text>
      <Text className="livechat-modal__text">
        {content}
      </Text>
    </FormModal>);

}

export default LiveChatModal;